module.exports = __webpack_public_path__ + "img/banner3_3_vi.2acc2df1.png";